<template>
  <div class="form-element" :class="{ 'form-element--horizontal': !vertical }">
    <label v-if="label" @click.capture.prevent :for="name"
      >{{ label }}
      <span v-if="value" class="label__value">{{ value }}</span>
      <slot name="tooltip"></slot>
    </label>
    <slot name="input"></slot>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "FormElement",
  props: {
    vertical: {
      default: true,
      type: Boolean
    },
    value: {
      required: false,
      type: [String, Number]
    },
    label: {
      required: false,
      type: String,
      default: ""
    },
    name: {
      required: false,
      type: String
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-element {
  margin: 5px;
  padding: 5px;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-weight: bolder;
}

.form-element--horizontal {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.form-element--horizontal > * {
  flex-grow: 1;
}

.form-element--horizontal > *:first-child {
  flex-grow: 2;
  margin-right: 10px;
}

:not(form-element--horizontal) > label {
  margin-bottom: 3px;
}

label {
  display: flex;
  justify-content: flex-start;
  text-transform: uppercase;
  align-items: center;
}

.label__value {
  font-weight: normal;
  font-style: oblique;
  margin-left: 5px;
  text-transform: none;
}

input[type="checkbox"] {
  position: relative;
  appearance: none;
  outline: none;
  width: 50px;
  height: 30px;
  background-color: white;
  border: 1px solid #d9dadc;
  border-radius: 50px;
  box-shadow: inset -20px 0 0 0 #ccc;
  transition-duration: 200ms;
}

input[type="checkbox"]:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  width: 26px;
  height: 26px;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
}

input[type="checkbox"]:checked {
  border-color: #4ed164;
  box-shadow: inset 20px 0 0 0 #4ed164;
}

input[type="checkbox"]:checked:after {
  left: 20px;
  box-shadow: -2px 4px 3px rgba(0, 0, 0, 0.05);
}

@media (max-width: 767px) {
  fieldset {
    width: 100%;
  }
  form {
    flex-grow: 1;
    flex-direction: column;
  }

  .form-element {
    width: auto;
    align-self: stretch;
  }

  :not(.form-element--horizontal) > label {
    margin-bottom: 14px;
  }
}
</style>
